import { useLayoutEffect } from 'react';

const useHiddenHeaderFooter = (containerClass: string): void => {
  useLayoutEffect(() => {
    if (containerClass) {
      const html = document.getElementsByTagName('html')[0];
      const body = document.getElementsByTagName('body')[0];
      const initialClass = body.className;
      body.className = `notranslate ${containerClass}`;

      return (): void => {
        html.removeAttribute('style');
        body.className = initialClass;
      };
    }
  }, [containerClass]);
};

export default useHiddenHeaderFooter;
